import { writable } from 'svelte/store'
import { user} from "$lib/stores/auth";
import {get} from "$lib/api";


export const currentCustomer = writable(typeof window !== 'undefined' ? sessionStorage.currentCustomer : null)

export const availableAssociates = writable(typeof window !== 'undefined' ? sessionStorage.availableAssociates : null)

export const userCustomer = writable(typeof window !== 'undefined' ? sessionStorage.userCustomer : null)

export const userAsAssociate = writable(typeof window !== 'undefined' ? sessionStorage.userAsAssociate : null)

user.subscribe(val => {
    if(val && typeof val.associations !== 'undefined'){
        userAsAssociate.set(val.associations[0])
    }

})